var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfPrevPage(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.13906 6.16683L10.9092 1.51521C11.4469 1.15522 11.8877 1.41933 11.8877 2.10265V11.1343C11.8877 11.8157 11.4469 12.0798 10.9092 11.7217L4.13906 7.0682C4.13906 7.0682 3.87683 6.88116 3.87683 6.61893C3.87683 6.35575 4.13906 6.16683 4.13906 6.16683ZM2.48858 0.978516H1.54867C1.02889 0.978516 0.608753 1.02363 0.608753 1.54246V11.6935C0.608753 12.2123 1.02889 12.2575 1.54867 12.2575H2.48858C3.00835 12.2575 3.42849 12.2123 3.42849 11.6935V1.54246C3.42849 1.02363 3.00835 0.978516 2.48858 0.978516Z",
    fill: "#00495F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfPrevPage);
export default __webpack_public_path__ + "static/media/pdfPrevPage.b66d7ffe0e1d18e7a32e1c14bf83707c.svg";
export { ForwardRef as ReactComponent };